import fetch from '../utils/fetch';
import {ApiURL} from './config';


class TaskApi {

    static store(task){
        return fetch(`${ApiURL}/task`, {
            method: 'POST',
            body: JSON.stringify(task),
            'Content-Type': 'application/json'
        });
    }

    static update(task){
        return fetch(`${ApiURL}/task/${task.id}`, {
            method: 'PUT',
            body: JSON.stringify(task),
            'Content-Type': 'application/json'
        });
    }

    static getMyTasks(date) {
        return fetch(`${ApiURL}/task/mine/${date}`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static getTaskType() {
        return fetch(`${ApiURL}/task/types`, {
            method: 'GET',
            'Content-Type': 'application/json'
        });
    }

    static delete(task){
        return fetch(`${ApiURL}/task/${task.id}`, {
            method: 'DELETE',
            'Content-Type': 'application/json'
        });
    }
}

export default TaskApi;


/** WEBPACK FOOTER **
 ** ./src/api/taskApi.js
 **/